import { RouterLink, type RouterLinkProps } from '../RouterLink';
import { ButtonLink, type ButtonLinkProps } from './ButtonLink';

export function NavigationLink({
	path,
	replaceLastPathOnly,
	matchSearchParams,
	...props
}: Omit<RouterLinkProps, 'children'> & Omit<ButtonLinkProps, 'selected' | 'onClick'>) {
	return (
		<RouterLink path={path} replaceLastPathOnly={replaceLastPathOnly} matchSearchParams={matchSearchParams}>
			{(selected, navigateTo) => <ButtonLink {...props} selected={selected} onClick={navigateTo} />}
		</RouterLink>
	);
}
